import React, { useState, useEffect } from 'react';
import { Auth } from './components/Auth';
import { CatManager } from './components/CatManager';
import { DogManager } from './components/DogManager';
import { User } from './types';
import { getCurrentUser } from './services/db';
import { Cat, Dog } from 'lucide-react';

const App: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [activeView, setActiveView] = useState<'cats' | 'dogs'>('cats');

  useEffect(() => {
    // Check for existing session
    const storedUser = getCurrentUser();
    if (storedUser) {
      setUser(storedUser);
    }
    setLoading(false);
  }, []);

  const handleLogin = (loggedInUser: User) => {
    localStorage.setItem('currentUser', JSON.stringify(loggedInUser));
    setUser(loggedInUser);
  };

  const handleLogout = () => {
    localStorage.removeItem('currentUser');
    setUser(null);
  };

  if (loading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-purple-600 border-t-transparent"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      {!user ? (
        <Auth onLogin={handleLogin} />
      ) : (
        <>
          {/* Animal Type Toggle */}
          <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 bg-white/90 backdrop-blur-md rounded-full p-1 shadow-lg border border-gray-200">
            <button
              onClick={() => setActiveView('cats')}
              className={`flex items-center gap-2 px-4 py-2 rounded-full transition-all ${
                activeView === 'cats'
                  ? 'bg-gradient-to-r from-purple-600 to-indigo-600 text-white shadow-md'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <Cat className="h-5 w-5" />
              <span className="font-medium hidden sm:inline">Gatos</span>
            </button>
            <button
              onClick={() => setActiveView('dogs')}
              className={`flex items-center gap-2 px-4 py-2 rounded-full transition-all ${
                activeView === 'dogs'
                  ? 'bg-gradient-to-r from-orange-600 to-red-600 text-white shadow-md'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <Dog className="h-5 w-5" />
              <span className="font-medium hidden sm:inline">Perros</span>
            </button>
          </div>

          {/* Content */}
          <div className="pt-16">
            {activeView === 'cats' ? (
              <CatManager user={user} onLogout={handleLogout} />
            ) : (
              <DogManager user={user} onLogout={handleLogout} onNavigateToCats={() => setActiveView('cats')} />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default App;